var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path, _polygon6, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCodepen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ede9e4;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.58 65.43 30.58 78.45 40.32 71.9 30.58 65.43"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.45 87.51 67.16 109.22 67.16 89.71 49.05 77.69 34.45 87.51"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "109.51 56.42 76.84 34.73 76.84 53.84 94.99 66.05 109.51 56.42"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72 62.25 57.73 71.84 72 81.31 86.27 71.84 72 62.25"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.16 53.84 67.16 34.73 34.49 56.42 49.01 66.05 67.16 53.84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.74,0H25.26C11.31,0,0,11.31,0,25.26v93.47c0,13.95,11.31,25.26,25.26,25.26h93.47c13.95,0,25.26-11.31,25.26-25.26V25.26c0-13.95-11.31-25.26-25.26-25.26ZM123.09,87.47c.01.91-.23,1.84-.76,2.66-.05.08-.1.16-.16.24-.37.51-.83.93-1.33,1.25l-46.11,30.6c-.77.53-1.7.84-2.71.84h-.05c-1,0-1.94-.31-2.71-.84l-46.11-30.6c-.51-.32-.97-.74-1.33-1.25-.06-.08-.11-.16-.16-.24-.52-.82-.77-1.75-.76-2.66v-30.99c-.01-.91.23-1.84.76-2.67.04-.06.08-.12.12-.18.38-.54.85-.98,1.37-1.31l46.11-30.6c1.56-1.06,3.91-1.06,5.46,0l46.11,30.6c.53.33,1,.77,1.38,1.31.04.06.08.12.12.18.53.83.77,1.75.76,2.67v30.99Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.84 89.71 76.84 109.22 109.55 87.51 94.95 77.69 76.84 89.71"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.42 78.45 113.42 65.43 103.68 71.9 113.42 78.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCodepen);
export default __webpack_public_path__ + "static/media/icon-codepen.5b8033cc629400b38807781cde3e6c8d.svg";
export { ForwardRef as ReactComponent };